import {
  DIRECT_LOAD_SUCCESS,
  DIRECT_LOAD_FAILED,
  DIRECT_LOAD_INVALID_REQUEST,
  DIRECT_LOAD_INVALID_CVV,
  DIRECT_LOAD_NO_ACCOUNT,
  DIRECT_LOAD_3D,
  DIRECT_LOAD_OPERATION_NOT_PERMITTED,
  DIRECT_LOAD_TRANSACTION_LIMIT_OVER,
  DIRECT_LOAD_NOT_SUFFICIENT_LIMIT,
  DIRECT_LOAD_TRANSACTION_LIMIT_EXCEEDED,
  DIRECT_LOAD_DECLINED,
  NETWORK_ERROR_DIRECT_LOAD,
  LOADING_DIRECT_LOAD,
  RESET_DIRECT_LOAD,
} from "../types";

const initialState = {
  isLoading: false,
  failed: false,
  pending: false,
  success: false,
  declined: false,
  invalidCvv: false,
  invalidRequest: false,
  noAccount: false,
  operationNotPermitted: false,
  transactionLimitOver: false,
  notSufficientLimit: false,
  transactionLimitExceeded: false,
  amount: 0,
  status: "",
  is3d: false,
  data: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_DIRECT_LOAD:
      return {
        ...state,
        isLoading: true,
        failed: false,
        success: false,
        pending: false,
        declined: false,
        invalidRequest: false,
        invalidCvv: false,
        noAccount: false,
        is3d: false,
        operationNotPermitted: false,
        transactionLimitOver: false,
        notSufficientLimit: false,
        transactionLimitExceeded: false,
        amount: 0,
        status: "",
        data: {},
      };

    case DIRECT_LOAD_SUCCESS:
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: true,
        pending: false,
        declined: false,
        invalidRequest: false,
        invalidCvv: false,
        noAccount: false,
        is3d: false,
        operationNotPermitted: false,
        transactionLimitOver: false,
        notSufficientLimit: false,
        transactionLimitExceeded: false,
        amount: action.payload.amount,
        status: "",
        data: action.payload,
      };

    case DIRECT_LOAD_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        pending: false,
        failed: true,
        declined: false,
        invalidRequest: false,
        invalidCvv: false,
        noAccount: false,
        is3d: false,
        operationNotPermitted: false,
        transactionLimitOver: false,
        notSufficientLimit: false,
        transactionLimitExceeded: false,
        amount: "",
        status: "Add balance failed !",
        data: action.payload,
      };

    case DIRECT_LOAD_DECLINED:
      return {
        ...state,
        isLoading: false,
        success: false,
        pending: false,
        failed: false,
        declined: true,
        invalidRequest: false,
        invalidCvv: false,
        noAccount: false,
        is3d: false,
        operationNotPermitted: false,
        transactionLimitOver: false,
        notSufficientLimit: false,
        transactionLimitExceeded: false,
        amount: "",
        status: "Add balance declined !",
        data: action.payload,
      };

    case DIRECT_LOAD_INVALID_CVV:
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: false,
        pending: false,
        declined: false,
        invalidRequest: false,
        invalidCvv: true,
        noAccount: false,
        is3d: false,
        operationNotPermitted: false,
        transactionLimitOver: false,
        notSufficientLimit: false,
        transactionLimitExceeded: false,
        amount: "",
        status: "Please enter valid CVV !",
        data: action.payload,
      };

    case DIRECT_LOAD_INVALID_REQUEST:
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: false,
        pending: false,
        declined: false,
        invalidRequest: true,
        invalidCvv: false,
        noAccount: false,
        operationNotPermitted: false,
        transactionLimitOver: false,
        notSufficientLimit: false,
        transactionLimitExceeded: false,
        is3d: false,
        amount: "",
        status: "Oops!, Something went wrong",
        data: action.payload,
      };

    case DIRECT_LOAD_NO_ACCOUNT:
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: false,
        pending: false,
        declined: false,
        invalidRequest: false,
        invalidCvv: false,
        noAccount: true,
        operationNotPermitted: false,
        transactionLimitOver: false,
        notSufficientLimit: false,
        transactionLimitExceeded: false,
        is3d: false,
        amount: "",
        status: "Wallet account is not created for wallet owner",
        data: action.payload,
      };

    case DIRECT_LOAD_3D:
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: false,
        declined: false,
        pending: false,
        invalidRequest: false,
        invalidCvv: false,
        noAccount: false,
        is3d: true,
        operationNotPermitted: false,
        transactionLimitOver: false,
        transactionLimitExceeded: false,
        notSufficientLimit: false,
        amount: "",
        status: "",
        data: action.payload,
      };

    case NETWORK_ERROR_DIRECT_LOAD:
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: false,
        pending: false,
        declined: false,
        invalidRequest: false,
        invalidCvv: false,
        noAccount: false,
        is3d: false,
        operationNotPermitted: false,
        transactionLimitOver: false,
        transactionLimitExceeded: false,
        notSufficientLimit: false,
        amount: "",
        data: {},
        status: "OOPS! Something went wrong.",
      };

    case DIRECT_LOAD_OPERATION_NOT_PERMITTED:
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: false,
        declined: false,
        pending: false,
        invalidRequest: false,
        invalidCvv: false,
        noAccount: false,
        is3d: false,
        operationNotPermitted: true,
        transactionLimitOver: false,
        notSufficientLimit: false,
        transactionLimitExceeded: false,
        amount: "",
        status: "Operation Not Permitted",
        data: action.payload,
      };

    case DIRECT_LOAD_TRANSACTION_LIMIT_OVER:
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: false,
        declined: false,
        pending: false,
        invalidRequest: false,
        invalidCvv: false,
        noAccount: false,
        is3d: false,
        operationNotPermitted: false,
        transactionLimitOver: true,
        notSufficientLimit: false,
        transactionLimitExceeded: false,
        amount: "",
        status: "Transaction Limit Over",
        data: action.payload,
      };

    case DIRECT_LOAD_NOT_SUFFICIENT_LIMIT:
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: false,
        declined: false,
        pending: false,
        invalidRequest: false,
        invalidCvv: false,
        noAccount: false,
        is3d: false,
        operationNotPermitted: false,
        transactionLimitOver: false,
        notSufficientLimit: true,
        transactionLimitExceeded: false,
        amount: "",
        status: "No Sufficient Limit",
        data: action.payload,
      };

    case DIRECT_LOAD_TRANSACTION_LIMIT_EXCEEDED:
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: false,
        declined: false,
        pending: false,
        invalidRequest: false,
        invalidCvv: false,
        noAccount: false,
        is3d: false,
        operationNotPermitted: false,
        transactionLimitOver: false,
        notSufficientLimit: false,
        transactionLimitExceeded: true,
        amount: "",
        status: "Transaction Limit Exceeded",
        data: action.payload,
      };

    case RESET_DIRECT_LOAD:
      return (state = initialState);

    default:
      return state;
  }
};
